import { getFramework, IFramework } from '@/framework';
import {
    getImageCutoutInfo,
    getImageCutoutState,
    IExternalMethodsProps,
    IExternalParamsProps,
    ImageCutoutInfo,
} from './states/image-cutout-state';

const IMAGE_CUTOUT_IS_IMAGE_CUTOUT_CHANGE_EVENT = 'image-cutout-is-image-cutout-change';

export class ImageCutoutPlugin {
    private framework: IFramework;
    constructor(id: string) {
        this.framework = getFramework(id);
    }

    static getCutoutEventName() {
        return IMAGE_CUTOUT_IS_IMAGE_CUTOUT_CHANGE_EVENT;
    }

    /** 获取抠图配置 */
    getConfig() {
        return {
            isCutout: getImageCutoutState(this.framework.identity).isImageCutout,
        };
    }

    onImageCutoutChange(callback: (isImageCutout: boolean) => void) {
        return this.framework.service.events.on(IMAGE_CUTOUT_IS_IMAGE_CUTOUT_CHANGE_EVENT, callback);
    }

    /** 打开抠图 */
    open(info: ImageCutoutInfo, externalMethods: IExternalMethodsProps, externalParams: IExternalParamsProps) {
        getImageCutoutState(this.framework.identity).setIsImageCutout(true);
        getImageCutoutState(this.framework.identity).setImageCutoutInfo(info);
        getImageCutoutState(this.framework.identity).setExternalMethods(externalMethods);
        getImageCutoutState(this.framework.identity).setExternalParams(externalParams);
        this.framework.service.editor.setDisableOperate(true);
        this.framework.service.events.emit(IMAGE_CUTOUT_IS_IMAGE_CUTOUT_CHANGE_EVENT, true);
    }

    resetConfig() {
        getImageCutoutState(this.framework.identity).setImageCutoutInfo(getImageCutoutInfo());
        this.framework.service.events.emit(IMAGE_CUTOUT_IS_IMAGE_CUTOUT_CHANGE_EVENT, false);
    }

    /** 关闭抠图 */
    close() {
        getImageCutoutState(this.framework.identity).setIsImageCutout(false);
        getImageCutoutState(this.framework.identity).setImageCutoutInfo(getImageCutoutInfo());
        this.framework.service.editor.setDisableOperate(false);
        this.framework.service.events.emit(IMAGE_CUTOUT_IS_IMAGE_CUTOUT_CHANGE_EVENT, false);
    }

    destroy() {
        this.close();
    }
}
